export default import.meta.ROLLDOWN_FILE_URL_UtSd2wWiGs0Sim15oE6Xxg